import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getChannel } from '../Common/CommonHelper';
import { IRIS_MARKETING_SLOT_URL_WITH_SEARCH } from '../Common/CommonConstants';

export const getBannerShopZoneInfo = () => {  // eslint-disable-line
    try {
        const context = RestClient.getContext();
        const channel = getChannel(context);

        const config = {
            url: IRIS_MARKETING_SLOT_URL_WITH_SEARCH.replace(/{searchTerm}/gi, 'cf-shoppable-zone'),
            apiHost: apiHosts.content,
            excludeVersion: true,
            isXCloudHeaderRequired: true,
            channel,
        };
        return RestClient.get(config).then((json) => json);
    } catch (e) {
        /* istanbul ignore next */
        return e;
    }
};
